module.exports = __webpack_public_path__ + "img/rotate_BG.283081cc.svg";